module.exports = __webpack_public_path__ + "img/consultant_verify_idcard_rear.0addd7b1.png";